import { InjectionToken } from '@angular/core';
import { AmplitudeConfig } from '../../models/amplitude-config/amplitude-config.model';

export const AMPLITUDE_CONFIG = new InjectionToken<AmplitudeConfig>(
    'amplitudeConfig',
);
